<script>
import i18n from '@/plugins/i18n'

export default {
  filters: {
    extraDataAppearance (data, hideOnNull = false) {
      const { value, type } = data
      if (!value) return hideOnNull ? '' : i18n.t('general.enterInformation')
      let parsedValue
      if (type === 'phone' && typeof value === 'string') {
        parsedValue = JSON.parse(value)
        if (parsedValue.number && parsedValue.phone) {
          return `+${parsedValue.number} ${parsedValue.phone}`
        }
      } else if (type === 'checkbox' && typeof value === 'string' && value.includes('[')) {
        parsedValue = JSON.parse(value)
        if (Array.isArray(parsedValue) && parsedValue.length > 0) {
          return parsedValue.join(', ')
        } else return hideOnNull ? '' : i18n.t('general.enterInformation')
      } else if (typeof value === 'string' && value.charAt(0) === '{') {
        let parsed = value
        try {
          parsed = JSON.stringify(JSON.parse(value), null, 4)
          parsed = `<pre style="white-space: pre-wrap;">${parsed}</pre>`
          return parsed
        } catch (error) {
          console.error(error)
          console.log('parsed')
          console.log(parsed)
        }
      }
      return value
    }
  }
}
</script>
